import { defineStore } from 'pinia'

export const useTimeStore = defineStore({
    id: 'time',

    state: () => {
        return {
            now: new Date()
        }
    },

    actions: {        
        updateTime () {
            this.now = new Date();
        },

        start () {
            setInterval(() => {
                this.updateTime()
            }, 1000 * 60)
        }
    }
});
